import { Col, Layout, message, Row, Space, Switch, Typography } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MailIcon from "../../../assets/icons/mail.svg";
import ArrowLeftIconComponent from "../../../components/ArrowLeftIconComponent";
import ConfirmationModalNotificationComponent from "../../../components/ConfirmationModalNotificationComponent";
import { getEmailNotifications } from "../../../helpers/constant";
import { INotification } from "../../../helpers/types";
import useFetchUserSettings from "../../../hooks/userHooks/useFetchUserSettings";
import { userService } from "../../../services";
import "./index.less";

const FanEmailNotificationPage = () => {
  const { t } = useTranslation();
  const notificationsInformations = getEmailNotifications(t);
  const { currentUserSettings } = useFetchUserSettings();
  const [notifications, setNotifications] = useState<INotification>({
    mediaPush: true,
    stream: true,
    scheduleStream: true,
    reminderStream: true,
    marketing: true
  });
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedFrequency, setSelectedFrequency] = useState<string | null>(null);
  const [previousNotifications, setPreviousNotifications] = useState(notifications);

  useEffect(() => {
    if (!currentUserSettings?.notification) return;

    const data = {
      mediaPush: currentUserSettings.notification.mediaPush,
      stream: currentUserSettings.notification.stream,
      scheduleStream: currentUserSettings.notification.scheduleStream,
      reminderStream: currentUserSettings.notification.reminderStream,
      marketing: currentUserSettings.notification.marketing
    }
    setNotifications(data);
    setPreviousNotifications(data);
  }, [currentUserSettings?.notification])

  // useEffect(() => {
  //   if (user) {
  //     setNotifications(user.notification);
  //     setPreviousNotifications(user.notification);
  //   }
  // }, [user]);

  const handleSwitchChange = async (e: boolean, frequency: string) => {
    if (e === false) {
      setSelectedFrequency(frequency);
      setIsConfirmationModalOpen(true);
    } else {
      const updatedNotifications = { ...notifications, [frequency]: e };
      setNotifications(updatedNotifications);
      setPreviousNotifications(notifications);

      await updateNotification(e, frequency, updatedNotifications);
    }
  };
  const updateNotification = async (e: boolean, frequency: string, updatedNotifications: typeof notifications) => {
    try {
      await userService.updateNotificationSetting(updatedNotifications);
    } catch (err) {
      setNotifications(previousNotifications);
      message.error(t("something-went-wrong"));
    }
  };

  return (
    <Layout>
      <Layout.Content className="content fanEmailNotificationWrapper gradient-background">
        <Row className="relative justify-content-center header-title-container-70">
          <ArrowLeftIconComponent top={1} />
          <Typography.Text className="header-title-black-24">{t("email-Notification-title")}</Typography.Text>
        </Row>
        <Row className="pl-20 pr-13 mt-50">
          <Space className="w-full gap-20" direction="vertical">
            {notificationsInformations.map((monetization, index) => {
              return (
                <Col key={index} className="FanNotificationBox">
                  <Row className="justify-content-between">
                    <Space direction="horizontal" className="items-start fanNotificationtitleandSubtile">
                      <img src={MailIcon} width="14px" height="14px" className="mt-7" alt="MailIcon" />
                      <Col className="d-flex flex-column">
                        <Typography.Text className="FanNotificationItemTitle m-0">{monetization.title}</Typography.Text>
                        <Typography.Text className="FanNotificationItemSubTitle m-0">{monetization.subTitle}</Typography.Text>
                      </Col>
                    </Space>
                    <Switch
                      className="switch revenueSwitch"
                      checked={notifications[monetization.frequency as keyof INotification]}
                      onChange={(e) => {
                        handleSwitchChange(e, monetization.frequency);
                      }}
                    />
                  </Row>
                </Col>
              );
            })}
          </Space>
        </Row>
      </Layout.Content>

      <ConfirmationModalNotificationComponent
        isOpen={isConfirmationModalOpen}
        onClose={() => setIsConfirmationModalOpen(false)}
        disableNotification={() => {
          if (selectedFrequency) {
            const updatedNotifications = { ...notifications, [selectedFrequency]: false };
            setNotifications(updatedNotifications);
            setPreviousNotifications(notifications);
            updateNotification(false, selectedFrequency, updatedNotifications);
            setIsConfirmationModalOpen(false);
          }
        }}
      />
    </Layout>
  );
};

export default FanEmailNotificationPage;
